import * as React from 'react';
import { warnAboutMissingStyles } from '@/lib/utils';

/**
 * @internal
 */
export function useWarnAboutMissingStyles() {
  React.useEffect(() => {
    warnAboutMissingStyles();
  }, []);
}
